import { NotificationsNone, Language, Settings, Search, Logout } from '@mui/icons-material'
import { Autocomplete, Badge, TextField } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentOffice, setOff } from '../app/officeSlice'
import styled from 'styled-components'
import { useSendLogoutMutation } from "../features/auth/authApiSlice"
import useAuth from "../features/hooks/useAuth"
import useTotalUnreadCount from "../features/hooks/useTotalUnreadCount"
import { useGetUsersQuery } from '../features/users/usersApiSlice'
import { useGetSupportUsersQuery } from '../features/supportusers/supportusersApiSlice'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import MenuIcon from "@mui/icons-material/Menu";
import logo1 from "../images/logo-final.png";
import SettingsIcon from "@mui/icons-material/Settings";
import nameStringFn from '../data/nameStringFn';
import NotificationDropdown from './ui/NotificationDropdown';

const TopContainer = styled.div`
    box-shadow: none;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    border-radius: 10px;
    top:0;
    left: auto;
    right: 0;
    color: #fff;
    border-bottom:1px solid black;
    transition: margin 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms, width 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
    width: 100%;
    height: 65px;
    /* background-color:   #a961f1; */
    background-image: linear-gradient(to right, #a961f1, #57ccf4);  
`
const Topbarwrapper = styled.div`
    display: flex;
    justify-content: space-between;
    -webkit-box-align:center;
    align-items:center;
`
const MenuIconWrapper = styled.div`
    /* display: none; */
    /* -webkit-box-align: center;
    -webkit-box-pack: center;
    position: relative;
    box-sizing: border-box;
    background-color: #edeff6;
    cursor: pointer;
    user-select: none;
    text-align: center;
    flex: 0 0 auto;
    /* font-size: 1.28 rem; */
    /* padding: 8px;
    border-radius: 50%;
    overflow: visible;
    transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    color: #5C5891;
    margin-left: 8px;
    margin-right: 8px;  */
    display: flex;
    align-items: center;
    margin-left: 8px;
    margin-right: 8px;
    cursor: pointer;

`
const SettingIconWrapper = styled.div`
  display: inline-flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  cursor: pointer;
  text-align: center;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  padding: 12px;
  font-size: 1.5rem;
  margin: 8px;
  background-color: #F5F7FA;
  color: #5C5891;
  border-radius: 50%;
  overflow: visible;
  flex: 0 0 auto;
`

const LogoImage = styled.img`
display: flex;
align-items: center;
margin-left:10px ;
margin-right: 5px;
justify-content: center;
width: 65px;
height: auto;
/* border-radius: 15%; */
object-fit: cover;
/* border: 1px solid black; */
box-shadow: inset;
`

const WelcomeText = styled.span`
    /* display: block; */
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-weight: 600;
    font-size: 1.07 rem;
    line-height: 1.6;
    letter-spacing: 0.0075em ;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space:pre-line;
    -webkit-box-flex:1;
    /* flex-grow: 1;   */
    color:  #184d53;
    /* justify-content:center; */
`
const SignoutButton = styled.button`
    display: inline-flex;
    -webkit-box-align: center;
    justify-content: center;
    position: relative;
    box-sizing: border-box;
    cursor: pointer;
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 1.75;
    letter-spacing: 0.02857em;
    text-transform: uppercase;
    min-width: 64px;
    padding: 6px 16px;
    border-radius: 4px;
    border-width: 0;
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    color: #fff;
    background-color: #ed6c02;
    box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12);
    margin: 8px;
`

const NameDisplayerWrapper = styled.div`
    display: inline-flex;
    flex-direction: column;
    position: relative;
    margin: 8px;
    width: 380px;
    color: #fff;
    justify-content:center;
`
const NameDisplayContainer = styled.div`    
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-weight: 400;
    font-size: 0.86 rem;
    line-height: 1.437em;
    letter-spacing: 0.00938em;
    color: #2b2b31;
    box-sizing: border-box;
    cursor: text;
    display: inline-flex;
    -webkit-box-align: center;
    position: relative;
    border-radius: 4px;
    background-color: #F5F7FA;
    align-items: center;
`
const SelectName = styled.select`
    display: block;
    padding-right: 32px;
    height: auto;
    min-height: 1.4375em;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    border-radius: 4px;
    cursor: pointer;
    font: inherit;
    letter-spacing: inherit;
    color: currentColor;
    border: 0;
    box-sizing: content-box;
    background: none;
    margin: 0;
    display: block;
    min-width: 0;
    width: 100%;
    animation-name: mui-auto-fill-cancel;
    animation-duration: 10ms;
    padding: 8.5px 14px;
`

const OptionName = styled.option`
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-weight: 400;
    font-size: 0.8571428571428571rem;
    line-height: 1.4375em;
    letter-spacing: 0.00938em;
    color: #2b2b31;
    cursor: text;
`

const TopRight = styled.div`
    display: flex;
    align-items: center;    
`

const LogoutWrapper = styled.div`
    cursor:pointer;
    margin-left: 10px;
`
const WrapperWelcomeText = styled.div`
align-items:center;

`
const LeftTopbar = styled.div`
display: flex;
align-items: center;
    
`
const CenterTopBar = styled.div`
display: flex;
margin-left: 100px;

`
const RightTopBar = styled.div`
display: flex;
align-items: center;
`

export const Topbar = () => {
    const [officeString, setOfficeString] = useState();
    const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);
    const dispatch = useDispatch();
    const [sendLogout, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useSendLogoutMutation()

    const navigate = useNavigate()

    const { user } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            user: data?.entities
        }),
    });
    const { supportuser } = useGetSupportUsersQuery("suppusersList", {
        selectFromResult: ({ data }) => ({
            supportuser: data?.entities
        }),
    });
    const Auth = useAuth();
    const id = Auth.id
    
    // Get total unread count across all inbox tabs
    const { totalUnreadCount, isLoading: isCountLoading } = useTotalUnreadCount();

    useEffect(() => {
        if (isSuccess) {
            if (Auth.supportuser) {
                navigate('/supportlogin')
            } else {
                navigate('/')
            }
        }
    }, [isSuccess, navigate])

    useEffect(() => {
        if (isError) {
            // Even if logout fails, we should clear local state and redirect
            // This ensures user is logged out on frontend even if backend fails
            console.error('Logout failed:', error)
            
            // Force logout on frontend regardless of backend response
            if (Auth.supportuser) {
                navigate('/supportlogin')
            } else {
                navigate('/')
            }
        }
    }, [isError, error, navigate, Auth.supportuser])

    useEffect(() => {
        if (supportuser && Auth.supportuser) {
            const role = supportuser[id].roles[0]
            setOfficeString(`${supportuser[id]?.name?.firstName} ${supportuser[id]?.name?.middleName} ${supportuser[id]?.name?.lastName}-${role}`)
        }
        if (user && !Auth.supportuser) {
            dispatch(setOff(Auth.office.mainCharge));
        }
    }, [supportuser, user])

    let myUser = {};
    let mapArray = [];
    if (Auth.supportuser && supportuser) {
        const tempObj = { ...supportuser[id] };
        mapArray = tempObj?.roles;
        myUser = supportuser[id];
    }

    if (!Auth.supportuser && user) {
        const tempObj = { ...user[id] }
        mapArray = [tempObj?.office?.mainCharge].concat(tempObj?.office?.additionalCharge)
        myUser = user[id];

    }

    const onChangeOfficeString = (newValue) => {
        if (newValue?.value.length) {
            dispatch(setOff(newValue.value));
        } else {
            dispatch(setOff(Auth.office.mainCharge));
        }
    }

    const handleNotificationClick = (event) => {
        setNotificationAnchorEl(event.currentTarget);
    };

    const handleNotificationClose = () => {
        setNotificationAnchorEl(null);
    };

    const selectedOffice = useSelector((state) => state.office.off);

    return (
        <TopContainer>
            <Topbarwrapper>
                <CenterTopBar>
                    <WrapperWelcomeText>
                        <WelcomeText>
                            {user && `Hi, ${(user && !Auth.supportuser) ? nameStringFn(user[Auth.id]) : nameStringFn(supportuser[Auth.id])}.\n Welcome to Asset Management System`}
                        </WelcomeText>
                    </WrapperWelcomeText>
                </CenterTopBar>
                <RightTopBar>
                    <NameDisplayerWrapper>
                        <NameDisplayContainer>
                            <Autocomplete
                                id="combo-box-demo"
                                size='small'
                                options={!Auth.supportuser ? Object.values(Auth.office).flat(3).map(x => { return { label: `${Auth.designation[x]} (${x})`, value: x } }) : []}
                                sx={{ width: 400 }}
                                value={!Auth.supportuser ? `${Auth.designation[selectedOffice]} (${selectedOffice})` : nameStringFn(myUser)}
                                onChange={(event, newValue) => onChangeOfficeString(newValue)}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                renderInput={(params) => <TextField {...params} label={!Auth.supportuser ? "Select Office" : "Support User"} />}
                            />
                        </NameDisplayContainer>
                    </NameDisplayerWrapper>
                    <MenuIconWrapper onClick={handleNotificationClick} style={{ cursor: 'pointer' }}>
                        {!Auth.supportuser && <Badge badgeContent={totalUnreadCount} color="error"  >
                            <NotificationsIcon sx={{ color: "purple", fontSize: "30px" }} />
                        </Badge>}
                    </MenuIconWrapper>
                    <SignoutButton onClick={sendLogout}>Sign Out</SignoutButton>
                </RightTopBar>
            </Topbarwrapper>
            
            {/* Notification Dropdown */}
            <NotificationDropdown 
                anchorEl={notificationAnchorEl}
                open={Boolean(notificationAnchorEl)}
                onClose={handleNotificationClose}
            />
        </TopContainer>
    )
}
